const translations = {
  "en": {
    "All Holdings": "All Holdings"
  },
  "zh-tw": {
    "All Holdings": "所有持股"
  }
};

export default translations;
